import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import { GetProjectEstimationTemplateResponse } from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'
import { IProjectDeliveryEstimationSettingsAPI } from './ProjectDeliveryEstimationSettings.controller'

export class ProjectDeliveryEstimationSettingsAPI
  extends InternalAPI
  implements IProjectDeliveryEstimationSettingsAPI
{
  constructor(
    partyId: string,
    private onRequestChanged: OnRequestChangeCallback
  ) {
    super(`/api/parties/${partyId}/settings/projectestimationtemplate`)
  }

  GetProjectDeliveryEstimationFileData =
    async (): Promise<GetProjectEstimationTemplateResponse> => {
      return await this.GetAsync<GetProjectEstimationTemplateResponse>({
        id: 'GetProjectDeliveryEstimationFileData',
        relativePath: '',
        onRequestChange: this.onRequestChanged,
      })
    }
  UploadProjectDeliveryEstimationFile = async (file: File) =>
    await this.UploadAsync<void>({
      id: 'UploadProjectDeliveryEstimationFile',
      relativePath: '',
      data: file,
      onRequestChange: this.onRequestChanged,
    })

  DeleteProjectDeliveryEstimationFile = async () =>
    await this.DeleteAsync({
      id: 'DeleteProjectDeliveryEstimationFile',
      relativePath: '',
      onRequestChange: this.onRequestChanged,
    })

  DownloadProjectDeliveryEstimationFile = async () =>
    await this.DownloadAsync({
      id: 'DownloadProjectDeliveryEstimationFile',
      relativePath: '/download',
      onRequestChange: this.onRequestChanged,
    })
}
